import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateCandidates } from "../../../store/actions/Candidates/candidateActions";
import { countries } from "../../constant/country";
import { visaTypes } from "../../constant/visaTypes";

const CandidateDetails = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  // Initialize form data with props (existing candidate details)
  const [formData, setFormData] = useState({
    dateOfBirth: props.candidate?.dateOfBirth ? new Date(props.candidate.dateOfBirth) : null,
    age: props.candidate?.age || "",
    nationality: props.candidate?.nationality || "",
    visaType: props.candidate?.visaType || "",
    visaExpiry: props.candidate?.visaExpiry ? new Date(props.candidate.visaExpiry) : null,
    maritalStatus: props.candidate?.maritalStatus || "",
  });

  useEffect(() => {
    setFormData({
      dateOfBirth: props.candidate?.dateOfBirth ? new Date(props.candidate.dateOfBirth) : null,
      age: props.candidate?.age || "",
      nationality: props.candidate?.nationality || "",
      visaType: props.candidate?.visaType || "",
      visaExpiry: props.candidate?.visaExpiry ? new Date(props.candidate.visaExpiry) : null,
      maritalStatus: props.candidate?.maritalStatus || "",
    });
  }, [props.candidate]);

  const [errors, setErrors] = useState({});
  const [editEmploye, setEditEmploye] = useState(false);

  useImperativeHandle(ref, () => ({
    showEmployeModal() {
      setEditEmploye(true);
    },
  }));

  const validate = () => {
    const newErrors = {};

    if (!formData.dateOfBirth) {
      newErrors.dateOfBirth = "Please enter your date of birth.";
    }
    if (!formData.nationality) {
      newErrors.nationality = "Please select your nationality.";
    }
    if (!formData.maritalStatus) {
      newErrors.maritalStatus = "Please select your marital status.";
    }
    setErrors(newErrors);
    // if (Object.keys(newErrors).length > 0) {
    //   toast.error("Please fill all the required fields.");
    // }
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = {
        dateOfBirth: formData?.dateOfBirth,
        age: formData?.age,
        nationality: formData?.nationality,
        maritalStatus: formData?.maritalStatus,
        visaExpiry: formData?.visaExpiry,
        visaType: formData?.visaType,
      };
      dispatch(
        updateCandidates(
          payload,
          setEditEmploye,
          props.candidate?._id,
          props.token
        )
      );
    }
  };

  return (
    <Offcanvas
      show={editEmploye}
      onHide={() => setEditEmploye(false)}
      className="offcanvas-end customeoff"
      placement="end"
    >
      <div className="offcanvas-header">
        <h5 className="modal-title">{props.Title || "Edit Candidate"}</h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setEditEmploye(false)}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Date Of Birth <span className="text-danger">*</span>
              </label>
              <DatePicker
                className="form-control"
                selected={formData.dateOfBirth}
                onChange={(date) => handleInputChange("dateOfBirth", date)}
              />
              {errors.dateOfBirth && (
                <small className="text-danger">{errors.dateOfBirth}</small>
              )}
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">Age</label>
              <input
                type="text"
                className="form-control"
                value={formData.age}
                onChange={(e) => handleInputChange("age", e.target.value)}
              />
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Nationality <span className="text-danger">*</span>
              </label>
              <select
                className="form-control form-select"
                value={formData.nationality}
                onChange={(e) =>
                  handleInputChange("nationality", e.target.value)
                }
              >
                <option value=""></option>
                {countries?.map((itm) => (
                  <option value={itm}>{itm}</option>
                ))}
              </select>
              {errors.nationality && (
                <small className="text-danger">{errors.nationality}</small>
              )}
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">RTW Check expiry</label>
              <DatePicker
                className="form-control"
                selected={formData.visaExpiry}
                onChange={(date) => handleInputChange("visaExpiry", date)}
              />
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">
                Marital Status <span className="text-danger">*</span>
              </label>
              <select
                className="form-control form-select"
                value={formData.maritalStatus}
                onChange={(e) =>
                  handleInputChange("maritalStatus", e.target.value)
                }
              >
                <option value=""></option>
                <option value="Married">Married</option>
                <option value="Single">Single</option>
              </select>
              {errors.maritalStatus && (
                <small className="text-danger">{errors.maritalStatus}</small>
              )}
            </div>
            <div className="col-xl-6 mb-3">
              <label className="form-label">Visa Type</label>
              <select
                className="form-control form-select"
                value={formData.visaType}
                onChange={(e) => handleInputChange("visaType", e.target.value)}
              >
                <option value=""></option>
                {visaTypes?.map((itm) => (
                  <option value={itm}>{itm}</option>
                ))}
              </select>
            </div>
          </div>
          <div>
            <button type="submit" className="btn btn-primary me-1">
              Update
            </button>
            <Link
              to={"#"}
              onClick={() => setEditEmploye(false)}
              className="btn btn-danger light ms-1"
            >
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </Offcanvas>
  );
});

export default CandidateDetails;
